

















import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import { ISortParameter } from "../../../../base/components/system";
import { TimeMeasure } from "../../../../base/utilities";
import { DomainRegistry } from "../../../domain";
import { User } from "../../../../base/domain/user";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { default as FormatSortSelector } from "./FormatSortSelector.vue";
import { default as FormatTableSelector } from "./FormatTableSelector.vue";

@Component({
  components: {
    FormatSortSelector,
    FormatTableSelector,
  }
})
export default class UserEditedFormatsSelector extends Mixins(ModelEditableMixin) {
  @Prop({ default: false })
  isShown: boolean;

  isLoaded: boolean = false;
  isFormatLoading: boolean = false;
  editedFormats: EditableFormatSummary[] = [];
  sortedValues: EditableFormatSummary[] = [];
  sortParameter: ISortParameter = {
    order: "descending",
    property: "lastUpdateDateTime",
  };

  get user(): User {
    return this.$store.getters.user as User;
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  mounted(): void {
    if (this.isShown) {
      this.isLoaded = true;
      this.loadUserEditedFormats();
    }
  }

  @Watch("isShown")
  onIsShownUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue && !this.isLoaded) {
      this.isLoaded = true;
      this.loadUserEditedFormats();
    }
  }

  async loadUserEditedFormats(): Promise<void> {
    this.isFormatLoading = true;
    this.editedFormats = [];
    await this.getUserEditedFormats()
    .then(d => this.editedFormats = d)
    .catch(e => {
      this.$error(
        "編集" + this.formatNameWording + "履歴取得失敗",
        "編集" + this.formatNameWording + "履歴を読み込めませんでした。",
        e
      );
    })
    .finally(() => this.isFormatLoading = false);
  }

  private getUserEditedFormats(): Promise<EditableFormatSummary[]> {
    return TimeMeasure.logAsync(
      "編集" + this.formatNameWording + "履歴取得",
      async () => {
        const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
        return repository.getUserEditedFormats(this.user.id);
      },
      "",
      TimeMeasure.debug
    );
  }

  onSortChanged(param: ISortParameter): void {
    this.sortParameter = param;
  }

  @Emit("formatDoubleClicked")
  formatDoubleClicked(): void {}
}
